import './tou.css';

function PrivacyPolicy() {
    return (
      <div>
        <h4>Astronomyshare.com Privacy Policy</h4>
        <h4>
          <b>Effective Date:</b> 2025-02-02
        </h4>
        <div className="left-align-section">
          <h4>
            At Astronomyshare.com ("we," "us," or "our"), we are committed to protecting your privacy. This Privacy Policy
            explains how we collect, use, and disclose your personal information when you use our website, Astronomyshare.com
            (the "Website").
          </h4>
  
          <h4>1. Information We Collect</h4>
          <h4>
            We collect as little personal information as possible, and only what is necessary for the operation of the
            Website. This includes:
          </h4>
          <ul className="toupp">
            <li>
              <b>Account Information:</b> When you create an account, we collect your username, email address, and a hashed
              version of your password. We do not store your password in plain text.
            </li>
            <li>
              <b>Usage Data:</b> We collect information about how you use the Website, such as the pages you visit, the links
              you click, and the features you use. This information is collected through the use of cookies and similar
              technologies.
            </li>
          </ul>
  
          <h4>2. How We Use Your Information</h4>
          <p>We use your information for the following purposes:</p>
          <ul className="toupp">
            <li>
              To provide and maintain the Website: This includes creating and managing your account, processing your requests,
              and providing customer support.
            </li>
            <li>
              To improve the Website: We use your usage data to understand how users interact with the Website and to identify
              areas for improvement.
            </li>
            <li>
              To communicate with you: We may use your email address to send you important updates about the Website, such as
              changes to our terms or privacy policy. We may also use your email address to respond to your inquiries and
              provide customer support.
            </li>
            <li>To reset your password: Your email address is used solely for password reset purposes.</li>
          </ul>
  
          <h4>3. How We Share Your Information</h4>
          <p>
            We do not share your personal information with third parties except as described in this Privacy Policy. We may
            disclose your information:
          </p>
          <ul className="toupp">
            <li>
              <b>To service providers:</b> We may share your information with service providers who assist us with providing
              and maintaining the Website, such as hosting providers and email service providers. These service providers are
              contractually obligated to protect your information.
            </li>
            <li>
              <b>To comply with legal obligations:</b> We may disclose your information if required to do so by law or in the
              good faith belief that such action is necessary to comply with a legal obligation, protect and defend our rights
              or property, or protect the personal safety of users of the Website or the public.
            </li>
          </ul>
  
          <h4>4. Cookies and Similar Technologies</h4>
          <p>
            We use cookies and similar technologies to collect usage data and to improve your experience on the Website.
            Cookies are small data files that are placed on your device when you visit a website. You can control the use of
            cookies through your browser settings. However, if you disable cookies, some features of the Website may not
            function properly.
          </p>
  
          <h4>5. Data Security</h4>
          <p>
            We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure.
            However, no method of transmission over the Internet or method of electronic storage is completely secure.
            Therefore, we cannot guarantee the absolute security of your information.
          </p>
  
          <h4>6. Children's Privacy</h4>
          <p>
            The Website is not intended for children under the age of 13. We do not knowingly collect personal information from
            children under 13. If you are under 13, please do not use the Website or provide any personal information to us.
          </p>
  
          <h4>7. Your Privacy Rights</h4>
          <p>You have the following rights with respect to your personal information:</p>
          <ul className="toupp">
            <li>
              <b>Access:</b> You have the right to request access to your personal information.
            </li>
            <li>
              <b>Correction:</b> You have the right to request correction of your personal information if it is inaccurate or
              incomplete.
            </li>
            <li>
              <b>Deletion:</b> You have the right to request deletion of your personal information.
            </li>
          </ul>
          <p>To exercise any of these rights, please contact us at jfrabell@yahoo.com.</p>
  
          <h4>8. Changes to this Privacy Policy</h4>
          <p>
            We may update this Privacy Policy from time to time. If we make material changes to this Privacy Policy, we will
            post the updated Privacy Policy on the Website and update the "Effective Date" at the top of this page. Your
            continued use of the Website following the posting of revised Privacy Policy means that you accept and agree to the
            changes.
          </p>
  
          <h4>9. Contact Us</h4>
          <p>If you have any questions about this Privacy Policy, please contact us at jfrabell@yahoo.com.</p>
        </div>
      </div>
    );
  }
  
  export default PrivacyPolicy;